import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import 'swiper/css';
import 'swiper/css/pagination';

const VARIANTS = {
  modules: {
    wrap: 'program-modules-wrap',
    swiper: 'program-modules-swiper',
    grid: 'program-modules-grid',
    card: 'program-module-card',
    ariaLabel: 'Módulos del programa',
  },
  outcomes: {
    wrap: 'program-outcomes-wrap',
    swiper: 'program-outcomes-swiper',
    grid: 'program-outcomes-grid',
    card: 'program-outcome-card',
    ariaLabel: 'Beneficios del programa',
  },
};

const ProgramCard = ({ item, cardClass }) => (
  <FlexContainer className={`${cardClass} flex-column`}>
    {item.icon ? (
      <i
        className={`fa-solid ${item.icon} ${cardClass}__icon`}
        aria-hidden="true"
      />
    ) : null}
    <h3>{item.title}</h3>
    <p>{item.desc}</p>
  </FlexContainer>
);

const ProgramCardsCarousel = ({ items, variant = 'modules' }) => {
  const config = VARIANTS[variant];

  return (
    <div className={config.wrap}>
      <Swiper
        className={config.swiper}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={16}
        slidesPerView={1.08}
        grabCursor
        aria-label={config.ariaLabel}
      >
        {items.map((item) => (
          <SwiperSlide key={item.title}>
            <ProgramCard item={item} cardClass={config.card} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={config.grid}>
        {items.map((item) => (
          <ProgramCard key={item.title} item={item} cardClass={config.card} />
        ))}
      </div>
    </div>
  );
};

export default ProgramCardsCarousel;
